<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('mating.UBN')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('mating.UBN') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('mating.Male')"
                                                :class="activeStep >= 1 ? activeClass : ''" @click="activeStep = 1">
                                                {{ $t('mating.Male') }}
                                            </button>                                            
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('mating.Female')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="activeStep = 2">
                                                {{ $t('mating.Female') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('mating.Date')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="activeStep = 3">
                                                {{ $t('mating.Date') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <UBN-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"
                                            :ubns="formData.ubns"
                                            @update:formData="updateFormData"
                                        />
                                        <male-info
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :males="formData.males"
                                            :prevStep="prevStep"
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <female-info 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :females="formData.females"
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            @update:formData="updateFormData"
                                        />
                                        <date-info 
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            ref="dateInfoRef"
                                            :formData="formData"
                                            :prevStep="prevStep"
                                            :emitter="emitter"                          
                                        />
                                        <div class="button-row d-flex">
                                            <button v-if="activeStep === 3" @click="saveForm" class="btn mb-0 btn-sm bg-gradient-success null null ms-auto" type="button">{{ $t('common.Save') }}</button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import UBNInfo from "./components/UBN.vue";
import MaleInfo from "./components/Male.vue";
import FemaleInfo from "./components/Female.vue";
import DateInfo from "./components/Date.vue";
import * as Choices from "choices.js";
import { nextTick } from 'vue'
import axios from 'axios'
import mitt from 'mitt';

export default {
    name: 'Mating_create_page',
    data() {
        return {
            emitter: mitt(),
            activeStep: 0,
            activeClass: "js-active position-relative",
            formSteps: 4,
            formData: {
                associationId: '',
                ubnId: '',
                ubn: '',
                maleLeased: false,
                selectedLeaseUBN: '',
                maleLeasedFromUBNId: '',
                maleId: '',
                femaleIds: '',
                dateFrom: null,
                dateTo: null,
                inbreedFactorOffspring: null,
                birthDate: null,
                ubns:[],
                males:[],
                females:[],
            },
            // Store Choices instance
            choicesInstanceUBN: null,
            choicesInstanceMale: null,
            choicesInstanceFemale: null
        };
    },
    components: {
        UBNInfo,
        MaleInfo,
        FemaleInfo,
        DateInfo
    },
    async mounted() 
    {    
        this.associationId = this.$route.params.id;
        await this.fetchAllUBN();        
    },
    methods: {
        async nextStep() {
            if (this.activeStep < this.formSteps -1) {
                this.activeStep += 1;
                //console.log(this.activeStep);
            } else {
                this.activeStep -= 1;
                //console.log(this.activeStep);
            }   
                            
            if(this.activeStep == 1) {
                this.fetchAllMale();
            }

            if(this.activeStep == 2) {
                this.fetchAllFemale();
            }
        },
        async prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;
                //console.log(this.activeStep);

                if(this.activeStep == 0) {
                    await this.fetchAllUBN();
                }

                if(this.activeStep == 1) {
                    this.fetchAllMale();
                }

                if(this.activeStep == 2) {
                    this.fetchAllFemale();
                }
            }
        },
        async fetchAllUBN() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const role = this.$store.state.roleName;
                const ubnId = this.$store.state.keeperLocationId;

                const response = await axios.get("Location/getallbyassociationmating", {
                    params: {
                        associationId: this.associationId
                    }
                });                
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    let avl_ubns = result.data;
                    
                    if (role === 'Keeper' && ubnId) {
                        // Ensure type match
                        avl_ubns = avl_ubns.filter(l => String(l.id) === String(ubnId));
                    }

                    //this.formData.ubns = avl_ubns;
                    this.formData.ubns.splice(0, this.formData.ubns.length, ...avl_ubns);
                    await nextTick();

                    if (role !== 'Keeper' || (role === 'Keeper' && this.formData.ubns.length > 1)) {
                        this.initializeChoicesDropdown({
                            id: "ubnId",
                            dataList: this.formData.ubns,
                            selectedValue: this.formData.ubnId,
                            instanceKey: "choicesInstanceUBN"
                        });
                    } else if (role === 'Keeper' && this.formData.ubns.length === 1) {                        
                        const single = this.formData.ubns[0];                         
                        this.formData.ubnId = single.id;
                        this.formData.ubn = `${single.ubn} - ${single.locationFullAddressDropDown}`;
                        console.log(this.formData.ubns.length);
                        console.log(this.formData.ubnId);
                        console.log(this.formData.ubn);
                    }                    
                } else {    
                    this.$showSuccess('errors.Error_fetching_ubns');
                }                                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async fetchAllMale() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const isAssociationAdmin = this.$store.state.roleName === 'AssociationAdmin';
                
                const response = await axios.get("Animal/getallmale", {
                    params: {
                        associationId: this.associationId,
                        animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                        ubnId: this.formData.ubnId,
                        maleLeased: this.formData.maleLeased,
                        isAssociationAdmin: isAssociationAdmin
                    }
                });
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.formData.males = result.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
                    
                } else {    
                    this.$showSuccess('errors.Error_fetching_males');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async fetchAllFemale() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const response = await axios.get("Animal/getallfemale", {
                    params: {
                        associationId: this.associationId,                        
                        animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                        ubnId: this.formData.ubnId
                    }
                });

                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.formData.females = result.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
                    
                } else {    
                    this.$showSuccess('errors.Error_fetching_females');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            // Destroy previous instance if it exists
            if (this[instanceKey]) {
                this[instanceKey].destroy();
            }

            // Initialize new Choices instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });

            // Set selected value if it exists in list
            if (selectedValue) {
                const optionExists = dataList.some(item => item.id === selectedValue);
                this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
            }
        },
        updateFormData(updatedData) {
            //this.formData = { ...this.formData, ...updatedData };
            Object.assign(this.formData, updatedData);
        },
        async saveForm() {
            const isValid = await this.$refs.dateInfoRef?.validateAndSubmit()
                if (!isValid) return;

            this.submitForm();
        },           
        async submitForm() {
            try {
                this.$store.commit('setShowLoading', true);

                if (this.formData.maleLeased === false) {
                    this.formData.maleLeasedFromUBNId = '';
                }

                const formData = new FormData();
                const ignoredKeys = [
                    'ubns', 'males', 'females','associationId', 'selectedLeaseUBN'
                ];

                for (const key of Object.keys(this.formData)) {
                    if (ignoredKeys.includes(key)) continue;

                    const value = this.formData[key];
                    const isDateField = ['birthDate', 'dateFrom', 'dateTo'];

                    if (isDateField.includes(key) && value instanceof Date) {
                        formData.append(key, value.toISOString().split('T')[0]);
                    } else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }

                if (this.$route.params.id) {
                    formData.append("associationId", this.$route.params.id);
                }   

                // Debug formData before sending
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                const response = await axios.post('/mating/create', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                const result = response.data;

                if (result.success) {
                    this.$showSuccess('errors.Success_mating_created_successfully');
                    this.$router.push('/mating');
                } else {
                    throw new Error('Form submission failed');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }
    }
}
</script>
<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}


.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}


.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}
</style>